import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {AuthenticationService} from "@tva/ng-migration/core";
import {CreDetailsService} from "@tva/ng-migration/cre-tracking/services/cre-details.service";
import {zip} from "rxjs";
import {UnsavedChangesService} from "@tva/ng-migration/shared/services/unsavedChanges.service";


@Component({
  selector: "app-cre-management-search-form",
  templateUrl: "./cre-management-search-form.component.html",
  styleUrls: ["./cre-management-search-form.component.css"],
})
export class CreManagementSearchFormComponent implements OnInit {
  isSearching: boolean;
  schoolsList: any[];

  form = new FormGroup({
    school: new FormControl(),
  });

  @Output() searched = new EventEmitter<any>();

  constructor(
    private authentication: AuthenticationService,
    private creDetails: CreDetailsService,
    private unsavedChanges: UnsavedChangesService
  ) {
  }

  ngOnInit(): void {
    this.clearFilters();
    this.loadSchools();
  }

  public clearFilters(): void {
    this.form.setValue({
      school: null,
    });
  }

  public search(): void {
      this.unsavedChanges.verify(()=>{
          if (this.validateForm()) {
              this.isSearching = true;
              this.loadCTEPathways(this.form.value.school);
          }
      })
  }
  public loadCTEPathways(schoolId: number): void{
    zip(
        this.creDetails.getCtePathways(schoolId),
        this.creDetails.getCteCourses(schoolId)
    ).subscribe(([pathways, schoolCourses]) => {
        const school = this.schoolsList.find(item => item.schoolId === schoolId);
        const activePathways = pathways.filter(item => item.status === 1 && item.isCurrentCte === 1)
        this.searched.emit({pathways: activePathways, school, schoolCourses});
        this.isSearching = false;
    })
  }

  private loadSchools(): void {
    this.schoolsList = this.authentication.getSchools();
  }

  private validateForm(): boolean {
    return this.form.valid;
  }
}
